// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__PxdqH","Open":"SideDrawer_Open__mtv9V","Close":"SideDrawer_Close__3xltO","Logo":"SideDrawer_Logo__10lzN"};